export interface IApplicationState {

    carouselStart: boolean;
    paytablePayoutArray: any

}

const initialState: IApplicationState = {
    carouselStart: false,
    paytablePayoutArray: []
};

export enum actionTypes {

    START_CAROUSEL_STATE = '@@paytableGame/START_CAROUSEL_STATE',
    PAYTABLE_PAYOUTS = '@@paytableGame/PAYTABLE_PAYOUTS',
}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const {paytablePayoutArray} = action;
    switch (action.type) {
        case actionTypes.START_CAROUSEL_STATE:
            return {
                ...state, carouselStart: true
            };
        case actionTypes.PAYTABLE_PAYOUTS:
            return {
                ...state, paytablePayoutArray: paytablePayoutArray
            };

        default:
            return state;
    }
}

export const actions = {
    startCarousel: (): any => ({type: actionTypes.START_CAROUSEL_STATE}),
    arrayOfPaytablePayouts: (paytablePayoutArray: any): any => ({
        type: actionTypes.PAYTABLE_PAYOUTS,
        paytablePayoutArray
    }),

};
